function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-figma-bg-blur-radius": 7.2,
  d: "M3 7.5a4 4 0 014-4h10a4 4 0 014 4H3z",
  fill: "#0073FF",
  fillOpacity: 0.25
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21 15.5a5 5 0 01-5 5H8a5 5 0 01-5-5v-7h18v7zm-7.291-3.56c-.485 0-.909.09-1.271.272-.305.15-.58.368-.825.656l.848.6c.155-.192.32-.333.496-.424.192-.096.419-.144.68-.144.266 0 .48.056.64.168a.573.573 0 01.248.497.512.512 0 01-.184.415c-.139.117-.344.176-.615.176h-.577v.936h.584c.304 0 .536.062.696.184a.57.57 0 01.232.48c0 .23-.085.408-.256.536-.17.128-.408.192-.712.192-.591 0-1.045-.237-1.36-.712l-.896.576c.491.741 1.254 1.112 2.289 1.112.677 0 1.218-.168 1.624-.504.378-.315.567-.701.567-1.16a1.2 1.2 0 00-.256-.76 1.484 1.484 0 00-.727-.488c.245-.112.436-.262.575-.448a1.13 1.13 0 00.224-.688c0-.432-.184-.784-.551-1.056-.379-.277-.87-.416-1.473-.416zm-4.02.096l-1.937.768.336.888 1.376-.568v4.24h1.184v-5.328h-.96z",
  fill: "#0073FF"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "calendar-active_svg__bgblur_1_484_6469_clip_path",
  transform: "translate(4.2 3.7)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 7.5a4 4 0 014-4h10a4 4 0 014 4H3z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "calendar-active_svg__clip0_484_6469"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})));

var SvgCalendarActive = function SvgCalendarActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendar-active_svg__clip0_484_6469)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.2,
    y: -3.7,
    width: 32.4,
    height: 18.4
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.6px)",
      height: "100%",
      width: "100%"
    },
    clipPath: "url(#calendar-active_svg__bgblur_1_484_6469_clip_path)"
  })), _ref, _ref2), _ref3);
};

export default SvgCalendarActive;